import { AlmeAppUtilsBase } from "../AlmeApp/AlmeAppState";
import { TerminateLiveChat } from "../LiveChat/AlmeLiveChatReportingEvents";
import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import * as Loaders from '@alme/storage-ts/CookieLoader';
const storageLoader = new Loaders.CookieLoader('almeSessionExt');
const cookieSessionLoader = new CookieAlmeSessionDataLoader(storageLoader);
const sessionDataLoader = cookieSessionLoader;
export class SessiontTimeoutUtils extends AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
        this.almeSession = sessionDataLoader.GetAlmeSessionData();
    }
    async onSessionTimeout() {
        var _a, _b;
        await TerminateLiveChat(this.apiUtils, this.almeState);
        this.apiUtils.createNewSessionData();
        const expiredResponse = this.getExpiredResponse();
        const _isLoggedin = ((_b = (_a = this.appConfig) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.platform) === "VISTA" ? true : false;
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { sessionExpired: true, isLoggedIn: _isLoggedin, lastActivityTime: undefined, lastEntryId: this.appConfig.history.expiredResponse.entryId, history: [expiredResponse], isLiveChatConnected: false }));
    }
    async onUserSessionRefresh() {
        if (this.almeState.isLiveChatConnected) {
            this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { lastActivityTime: Date.now() }));
        }
        else {
            const variableName = "UserRefreshedSessionTimeout";
            await this.apiUtils.sendReportingEvent(variableName, variableName);
        }
    }
    getExpiredResponse() {
        var _a;
        const responseRevision = 1;
        return {
            id: this.appConfig.history.expiredResponse.entryId,
            userId: ((_a = this.almeSession) === null || _a === void 0 ? void 0 : _a.userId) || "",
            text: this.appConfig.expiredErrorResponse,
            responseRevision: responseRevision,
            displayLinkCollection: {
                Sections: [],
                Metadata: null,
            },
            navUrl: null,
            responseActions: [],
            deferredAppCall: null,
            maskedInput: null,
            isReverted: false,
            extensionData: {
                entryId: this.appConfig.history.expiredResponse.entryId,
                chatId: "",
                MessageIndex: -1,
            },
        };
    }
}
